import { type AutocompleteConfig, type FormConfig, FormDefaultAttributes, type FormElementConfig } from '@common';

export const parcelGroupModalFormConfig: FormConfig = {
  name: 'parcelGroupModalFormConfig',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      component: 'text',
      name: 'name',
      settings: {
        needTranslate: true,
        grid: 12
      },
      attributes: {
        label: 'parcel.dialog.newParcelGroup.groupName'
      },
      validators: [
        {
          validator: 'required'
        },
        {
          validator: 'length',
          settings: {
            max: 255
          }
        }
      ]
    }
  ]
};

export const getFilterFormConfig = (actualCropName?: string): FormConfig => ({
  name: 'filterFormConfig',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      component: 'text',
      name: 'parcelName',
      settings: {
        needTranslate: true,
        grid: 6
      },
      attributes: {
        label: 'parcel.dialog.newParcelGroup.parcelName'
      }
    },
    {
      component: 'autocomplete',
      name: 'currentCrop',
      settings: {
        needTranslate: true,
        grid: 6,
        visible: !actualCropName,
        hideGridSlotWhenInvisible: true
      },
      attributes: {
        label: 'parcel.dialog.newParcelGroup.currentCrop',
        itemTitle: 'name',
        itemValue: 'code'
      }
    } as AutocompleteConfig,
    {
      component: 'display',
      name: 'actualCropName',
      settings: {
        needTranslate: true,
        grid: 6,
        defaultValue: actualCropName,
        visible: !!actualCropName,
        hideGridSlotWhenInvisible: true
      },
      attributes: {
        label: 'parcel.dialog.newParcelGroup.actualCropName'
      }
    } as FormElementConfig
  ]
});
